// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { SparseLocation, SparseLocationWithParent } from '@/sparse/api/types';

/**
 * Returns the ID of the site a location is at, which is the location's own ID for a site
 */
export function toSiteId(
  location: SparseLocation | SparseLocationWithParent
): string {
  if ('parentLocation' in location && location.parentLocation) {
    return location.parentLocation.id;
  }

  return location.id;
}
